import { AnalyticsService } from './../analytics/analytics.service';
import { Observable } from 'rxjs/Observable';
import { Http, RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Settings } from './../settings/settings';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import * as en from 'date-fns/locale/en';
import { ISubscription } from 'rxjs/Subscription';
import { AuthService, User } from './../user/auth.service';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { RegistryService } from '../registry/registry.service';
import { environment } from './../../environments/environment';
import { Intercom } from 'ng-intercom';
import { DatepickerOptions } from 'ng2-datepicker';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';

@Component({
  selector: 'app-personal-temp-createmode',
  templateUrl: './personal-temp-createmode.component.html',
  styleUrls: ['./personal-temp-createmode.component.scss'],
  providers: [SettingsService, CustomValidatorsService]
})
export class PersonalTempCreateModeComponent implements OnInit {
  @Output() saved: EventEmitter<string> = new EventEmitter<string>();
  @Output() processing: EventEmitter<string> = new EventEmitter<string>();
  @Input() skipLoad: boolean;
  @Input() mode: string;
  public hitchdForm: FormGroup;
  buttonText = 'Get Started';
  user: User;
  public procesing: boolean;
  public registryNameAvailable?: boolean;
  days: Array<number>;
  years: Array<number>;
  registryName: string;
  token: string;
  currency: string
  country:string;
  guestCount = 0;
  noDate = false;
  noGuestCount = false;
  hasStripeSetup = false;
  submitting = false; // @ollie - set this to true to view the spinner mode indefinately - set back to false when you are done.5
  slide = 3;
  date: Date = new Date(Date.now());
  yourName: string;

  partnersName: string;

  errorMessage: string;
  socialSubmitting = false;
  subscription: ISubscription;
  submitted = false;
  emailSet = false;
  options: DatepickerOptions = {
    minYear: 2018,
    maxYear: 2025,
    displayFormat: 'MMMM D YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,
    barTitleIfEmpty: 'Click to select a date',
    //  placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    //  addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };

  constructor(
    private _http: Http,
    private _router: Router,
    private _authService: AuthService,
    private _settingsService: SettingsService,
    private _fb: FormBuilder,
    private _registryFirebaseService: RegistryFirebaseService,
    private _validatorService: CustomValidatorsService,
    private _registryService: RegistryService,
    private _analyticsService: AnalyticsService,
    private _intercom: Intercom,
  ) {
    document.title = 'Sign up | Hitchd';
    
  }



  onDateSelect(date: any) {

  }
  setEmail() {
    this.emailSet = true;
  }
  getSlideNameByStepNumber(step:number){
    switch(step){
      case 0: {
        return "names - step 1";
      }
      case 1: {
        return "wedding details - step 2";
      }
      case 2: {
        return "email details - step 3";
      }
    }
  }
  showSlide(isForward: boolean) {    
    if (this.yourName && this.partnersName) {
      this.registryName = this.yourName.trim().toLowerCase() + 'and' + this.partnersName.trim().toLowerCase();
    }
    if (isForward) {
     let stepName = this.getSlideNameByStepNumber(this.slide)
      this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: this.slide + 1, destination_step_name:stepName });
      if (this.slide === 2) {
        this.slide = this.slide + 1;
      
      } else {

        if (!this.noDate && this.date) {
          this.hitchdForm.controls['weddingDay'].setValue(this.date.getDate());
          this.hitchdForm.controls['weddingMonth'].setValue(this.date.getMonth() + 1);
          this.hitchdForm.controls['weddingYear'].setValue(this.date.getFullYear());
        }

        this.slide = this.slide + 1;
      }
    } else if (this.slide === 3) {
      this.slide = this.slide + 1;
   

    }
    if (!isForward) {
      this._analyticsService.trackEvent('Signup Form - Back button clicked', { step: this.slide - 1 });
      if (this.slide === 0) {

      }
      else {
        this.slide = this.slide - 1;
      }
    }

  }

  ngOnInit() {
    this.date = new Date(Date.now());
    this.date.setMonth(this.date.getMonth() + 6);
    this._http.get('https://api.ipdata.co/?api-key=0aca3a36be4c02047be573615c60b4955a648594bde67ca7da76a83f').subscribe(result => {
      if (result && result.status === 200) {
        const resultBody = result.json();
        let country = resultBody.country_code;
        let currency = '';

        switch (country) {
          case 'AU': {
            currency = 'AUD';
            break;
          }
          case 'MX': {
            currency = 'MXN';
            break;
          }
          case 'CA': {
            currency = 'CAD';
            break;
          }
          case 'GB': {
            currency = 'GBP';
            break;
          }
          case 'NZ': {
            currency = 'NZD';
            break;
          }
          case 'US': {
            currency = 'USD';
            break;
          }
          case 'US': {
            currency = 'USD';
            break;
          }
          case 'AT': {
            currency = 'EUR';
            break;
          } case 'BE': {
            currency = 'EUR';
            break;
          }
          case 'ES': {
            currency = 'EUR';
            break;
          }
          case 'EE': {
            currency = 'EUR';
            break;
          } case 'FI': {
            currency = 'EUR';
            break;
          } case 'FR': {
            currency = 'EUR';
            break;
          } case 'DE': {
            currency = 'EUR';
            break;
          } case 'GR': {
            currency = 'EUR';
            break;
          } case 'IE': {
            currency = 'EUR';
            break;
          } case 'IT': {
            currency = 'EUR';
            break;
          } case 'LV': {
            currency = 'EUR';
            break;
          } case 'LT': {
            currency = 'EUR';
            break;
          } case 'LU': {
            currency = 'EUR';
            break;
          } case 'NL': {
            currency = 'EUR';
            break;
          } case 'PT': {
            currency = 'EUR';
            break;
          }
          case 'SG': {
            currency = 'SGD';
            break;
          }
          case 'HK': {
            currency = 'HKD';
            break;
          }
          case 'US': {
            currency = 'USD';
            break;
          }

          case 'SE': {
            currency = 'SEK';
            break;
          }

          case 'NO': {
            currency = 'NOK';
            break;
          }  
          case 'CH': {
            currency = 'CHF';
            break;
          }


          default: {
            currency = 'USD';
            country = 'US';
          }
        }

        this.currency = currency;       
        this.country = country;
        this.setCurrency();
        
        this.hitchdForm.controls['country'].setValue(country);
        this.hitchdForm.controls['currency'].setValue(currency);

      }
    });

    const body = document.getElementsByTagName('body')[0];
    // body.classList.add('starting-off');

    this.populateDateDropDownValues();
    this.hitchdForm = this._fb.group({
      firstName: ['You', []],
      lastName: ['', []],
      partnerFirstName: ['Fiance', []],
      partnerLastName: ['', []],
      introductionText: 
      [
        'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.'
      ],
      weddingDay: ['', []],
      weddingMonth: ['', []],
      weddingYear: ['', []],
      registryName: ['', [ Validators.minLength(5), Validators.maxLength(65)
        , Validators.pattern(/^(?=.*[a-zA-Z].*)([a-zA-Z0-9]+)$/), this.checkDomainName.bind(this)]],

      country: ['US', [Validators.required]],
      currency: ['USD', [Validators.required]],
      password: ['', [Validators.required, this._validatorService.containsUpperCase, Validators.minLength(8)]],
      email: ['', [Validators.required, this._validatorService.validateEmail]],
      guestCount: []
    });

    if (!this.skipLoad) {

      this.buttonText = 'Save';
    }
    if (this._authService.user) {
      this._authService.user.take(1).subscribe(user => {
        if (user) {
          this._registryFirebaseService.regforUser().take(1).subscribe((registry) => {
            if (registry) {
               location.href = '/registry';
              // this._router.navigate(['registry']);
            }
          });

        }
      });
    }

  }

  onCheckledGuestCount(checked){
    if (checked) {
      this.noGuestCount = true;
      this.hitchdForm.controls['guestCount'].setValue(null);
      this.hitchdForm.controls['guestCount'].clearValidators();
      this.guestCount = null;   

    } else {
      this.noGuestCount = false;  

      this.hitchdForm.controls['guestCount'].setValidators(Validators.required);
    }
    this.hitchdForm.markAsTouched();
  }

  onCheckled(checked: boolean) {
    this.date = null;
    if (checked) {
      this.noDate = true;

      this.hitchdForm.controls['weddingDay'].clearValidators();
      this.hitchdForm.controls['weddingMonth'].clearValidators();
      this.hitchdForm.controls['weddingYear'].clearValidators();
      this.hitchdForm.controls['weddingDay'].setValue(null);
      this.hitchdForm.controls['weddingMonth'].setValue(null);
      this.hitchdForm.controls['weddingYear'].setValue(null);
    } else {
      this.noDate = false;
      this.date = new Date();
      this.hitchdForm.controls['weddingDay'].setValidators(Validators.required);
      this.hitchdForm.controls['weddingMonth'].setValidators(Validators.required);
      this.hitchdForm.controls['weddingYear'].setValidators(Validators.required);
      this.hitchdForm.controls['weddingDay'].setValue(null);
      this.hitchdForm.controls['weddingMonth'].setValue(null);
      this.hitchdForm.controls['weddingYear'].setValue(null);
    }
    this.hitchdForm.markAsTouched();
  }

  checkDomainName(control: AbstractControl) {
    if (this.hitchdForm && control && control.value) {
      const regName: string = control.value;
      this._registryFirebaseService.registryByName(regName.toLowerCase()).subscribe(registry => {

        if (registry) {
          this.hitchdForm.controls['registryName'].setErrors({ 'registryNotavailable': true });
        }


      });
    }
  }

  setCurrency() {
    switch (this.country) {
      case 'AU': {
        this.currency = 'AUD';
        this.hitchdForm.controls['currency'].setValue('AUD');
        break;
      }
      case 'US': {
        this.currency = 'USD';
        this.hitchdForm.controls['currency'].setValue('USD');
        break;
      }
      case 'GB': {
        this.currency = 'GBP';
        this.hitchdForm.controls['currency'].setValue('GBP');
        break;
      }
      case 'DK': {
        this.hitchdForm.controls['currency'].setValue('DKK');
        break;
      }
      case 'NZ': {
        this.hitchdForm.controls['currency'].setValue('NZD');
        break;
      }

      case 'JP': {
        this.hitchdForm.controls['currency'].setValue('JPY');
        break;
      }

      case 'CA': {
        this.hitchdForm.controls['currency'].setValue('CAD');
        break;
      }
      case 'AT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'BE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'EE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'FI': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'FR': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'DE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'GR': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'IE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'IT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'LV': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'LT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'LU': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'NL': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'PT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'SK': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'SI': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'ES': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'SG': {
        this.hitchdForm.controls['currency'].setValue('SGD');
        break;
      }
      case 'SG': {
        this.hitchdForm.controls['currency'].setValue('USD');
        break;
      }
      case 'HK': {
        this.hitchdForm.controls['currency'].setValue('HKD');
        break;
      }

      case 'SE': {
        this.hitchdForm.controls['currency'].setValue('SEK');
        break;
      }
      case 'CH': {
        this.hitchdForm.controls['currency'].setValue('CHF');
        break;
      }
      case 'NO': {
        this.hitchdForm.controls['currency'].setValue('NOK');
        break;
      }
      case 'JP': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'MX': {
        this.hitchdForm.controls['currency'].setValue('MXN');
        break;
      }
    }
  }

 
  markFormAsTouched() {
    for (const key in this.hitchdForm.controls) {
      if (this.hitchdForm.controls.hasOwnProperty(key)) {
        const control: FormControl = <FormControl>this.hitchdForm.controls[key];
        {
          control.markAsTouched();
        }
      }
    }
  }

  



  CreateRegistryV2(): Promise<any> {
    const form: any = this.hitchdForm.value;
    form.guestCount = this.guestCount;
    form.backgroundHeaderImageUrl = 'https://images.unsplash.com/photo-1527904219733-fddc74937915?hex=#1A1E1B';
    form.introTitle = 'Welcome to our registry';
    form.introductionText = 
    'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
    if (form.firstName && form.partnerFirstName) {
      form.hashtag = form.firstName.toLowerCase().trim() + 'and' + form.partnerFirstName.toLowerCase().trim();
    } else {
      form.hashtag = '';
      form.hideHashtag = true;
    }
    form.registryName = this._registryFirebaseService.generateUniqueUrlPath()
    form.showRecommendedAmount = false;
    const campaign = localStorage.getItem('utm_campaign');
    const referal_user_id = localStorage.getItem('referal_id');
    const source = localStorage.getItem('utm_source');
    const landingPage = localStorage.getItem('landingPage');
    const partnershipId = localStorage.getItem('partnershipId');
    if (landingPage) {
      form.landingPage = landingPage;

    }
    if (source) {
      form.source = source;
    }
    if (campaign) {
      form.campaign = campaign;
    }
    if(referal_user_id){
      form.referalUserId = referal_user_id;
    }



if (partnershipId) {
      form.partnershipId = partnershipId;
    }

    this._analyticsService.update({ campaign: campaign, source: source, landingPage: landingPage  });
    // if ((window as any).analytics && (window as any).analytics.user) {
    //   const traits = (window as any).analytics.user().traits();
    //   form.rollouts =  {
    //     rollout_test: 'pricing',
    //     rollout_country: traits.rollout_country,
    //     rollout_currency: traits.rollout_currency,
    //     rollout_in_pricing_test: traits.rollout_in_pricing_test,
    //     rollout_originalCountry: traits.rollout_originalCountry,
    //     rollout_price: traits.rollout_price,
    //     rollout_price_segment: traits.rollout_price_segment,
    //     rollout_userId: traits.rollout_userId
    //   };
    // }


    form.email = null;
    form.password = null;
    form.userId = this.user.uid;
    const formValue: any = JSON.stringify(form);

    localStorage.setItem('tempReg', formValue);

return this._registryFirebaseService.createRegistry(formValue, this.user);

  }

  CreateRegistry(): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });

    const form: any = this.hitchdForm.value;
    form.token = this.token;

    // form.baseRegistryTemplate = localStorage.getItem('baseRegistryName');
    if (!this.noDate && this.date) {
      form.weddingDay = (this.date.getDate());
      form.weddingMonth = (this.date.getMonth() + 1);
      form.weddingYear = (this.date.getFullYear());
    }
    //

    form.backgroundHeaderImageUrl = 'https://images.unsplash.com/photo-1527904219733-fddc74937915?hex=#1A1E1B';
    form.introTitle = 'Welcome to our registry';
    form.introductionText = 'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
    if (form.firstName && form.partnerFirstName) {
      form.hashtag = form.firstName.toLowerCase().trim() + 'and' + form.partnerFirstName.toLowerCase().trim();
    } else {
      form.hashtag = '';
      form.hideHashtag = true;
    }
    form.guestCount = this.guestCount;
    form.registryName = (form.registryName as string).toLowerCase();
    const campaign = localStorage.getItem('utm_campaign');
    const source = localStorage.getItem('utm_source');
    const referal_user_id = localStorage.getItem('referal_id');
    const landingPage = localStorage.getItem('landingPage');
    const partnershipId = localStorage.getItem('partnershipId');
    if (landingPage) {
      form.landingPage = landingPage;

    }
    if (source) {
      form.source = source;
    }
    if (campaign) {
      form.campaign = campaign;
    }

    if(referal_user_id){
      form.referalUserId = referal_user_id;
    }


if (partnershipId) {
      form.partnershipId = partnershipId;
    }

    this._analyticsService.update({ campaign: campaign, source: source, landingPage: landingPage  });
    if ((window as any).analytics){
      const traits = (window as any).analytics.user().traits();
      form.rollouts =  {
        rollout_test: 'pricing',
        rollout_country: traits.rollout_country,
        rollout_currency: traits.rollout_currency,
        rollout_in_pricing_test: traits.rollout_in_pricing_test,
        rollout_originalCountry: traits.rollout_originalCountry,
        rollout_price: traits.rollout_price,
        rollout_price_segment: traits.rollout_price_segment,
        rollout_userId: traits.rollout_userId
      };
    }


    form.email = null;
    form.password = null;

    const formValue: any = JSON.stringify(form);

    return this._http.post(environment.firebase.clouldFunctionHost + '/createRegistryV2', formValue, options)
      .map(response => {

        const formdata = JSON.parse(formValue);
        if (formdata && formdata.firstName) {
          this._analyticsService.update({ name: formdata.firstName });
        }
        this._analyticsService.update({ registryUrl: 'https://www.hitchd.com/' + this.registryName });

        return response;
      });

  }

  save(goToCreateGift, fullScreenSpinner: boolean) {
    this.submitting = true;

    this.markFormAsTouched();
    if (this.hitchdForm.valid) {
   this.CreateRegistryV2()
// this.CreateRegistry()

        .then(x => {
          const baseTemplate = localStorage.getItem('baseRegistryName');
          // this._authService.sendEmailVerification(this.user.email, this.user.uid);
          this.redirectAfterCreating();
        });
    }
  }

  redirectAfterCreating() {
    this._registryService.emitWelcomePopup();
    this._registryService.sendFbTrackEvent('Get-started completed');
   this._router.navigate(['/setup']);


 //   location.href = '/registry';
  }


  populateDateDropDownValues() {
    this.days = new Array();
    for (let i = 1; i < 32; i++) {
      this.days.push(i);
    }

    this.years = new Array();
    for (let i = 2018; i < 2035; i++) {
      this.years.push(i);
    }
  }





  signInFacebook() {
    this.hitchdForm.controls['email'].clearValidators();
    this.hitchdForm.controls['password'].clearValidators();
    this.submitting = true;
    this._authService.facebookLogin().then(x => {

      this.subscription = this._authService.user.subscribe(user => {

        if (user != null) {
          this.submitting = true;
          this.markFormAsTouched();
          this._authService.authToken().subscribe(token => {
            this.token = token;
            this.CreateRegistry().subscribe(x => {
              this._registryService.emitWelcomePopup();
              this._registryService.sendFbTrackEvent('Get-started completed');

              location.href = '/registry';
            });
          });
        }
      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {
          this.errorMessage = 'The email address is already in use';
        }

        this.socialSubmitting = false;
        this.submitting = false;
      });
  }


  signInGoogle() {
    this.hitchdForm.controls['email'].clearValidators();
    this.hitchdForm.controls['password'].clearValidators();
    this.submitting = true;
    this._authService.googleLogin().then(x => {

      this.subscription = this._authService.user.subscribe(user => {

        if (user != null) {
          this.submitting = true;
          this.markFormAsTouched();
          this._authService.authToken().subscribe(token => {
            this.token = token;
            this.CreateRegistry().subscribe(x => {
              this._registryService.emitWelcomePopup();
              this._registryService.sendFbTrackEvent('Get-started completed');

              location.href = '/registry';
            });
          });
        }
      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {
          this.errorMessage = 'The email address is already in use';
        }

        this.socialSubmitting = false;
        this.submitting = false;
      });
  }



  setFullStoryId(email) {
    const FS = window['FS'];
    if (FS) {
      // This is an example script - don't forget to change it!
      FS.identify(email, {
        email: email,
        // TODO: Add your own custom user variables here, details at
        // http://help.fullstory.com/develop-js/setuservars
        reviewsWritten_int: 14
      });
    }
  }

  submit() {
    this.submitted = true;
    this.processing.emit('done');
    this.submitting = true;
    if (this.hitchdForm.valid) {
      const email = this.hitchdForm.controls['email'].value;
      const password = this.hitchdForm.controls['password'].value;
      localStorage.removeItem("dismiss_reg_setup");
      this._authService.signup(email, password).catch(
        (e) => {

          this.processing.emit('stop');
          if (e.message === 'The email address is already in use by another account.') {
            this.errorMessage = 'The email address is already in use';
          } else {
            this.errorMessage = e.message;
          }
          this.submitting = false;


        }
      ).then((user: User) => {


        if (user != null) {

          this.submitting = false;
          this.user = user;
          this._registryService.sendFbTrackEvent('Sign up');
          if (!this._analyticsService.skipEuMarketing) {
            this._intercom.boot({ email: user.email, user_id: user.uid, name: null });
          }
          this.setFullStoryId(user.email);
          this._authService.authToken().subscribe(token => {
            this.token = token;
            this.save(false, false);
          });
        }
      }
      );
    } else {
      this.submitted = false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/personal-temp-createmode/personal-temp-createmode.component.ts